const Api = {};

Api.install = function (Vue, options) {
  if(!options.hasOwnProperty('baseUrl')){
    throw new Error('API: BaseURL not found!');
  }

  if(!options.hasOwnProperty('repositories')){
    throw new Error('Error: Repositories not found!');
  }

  Vue.prototype.$repository = function (resource, baseEndpoint = null) {
    const { repositories } = options;
    const baseUrl = baseEndpoint || options.baseUrl;

    if(!resource || !repositories.hasOwnProperty(resource)){
      throw new Error('API: Resource not found!');
    }

    return new repositories[resource](baseUrl)
  }
}

export default Api;